export const MIN_PHONE_DIGITS = 7
export const MAX_PHONE_DIGITS = 15
export const PHONE_INPUT_MAX_LENGTH = 32
export const PHONE_VALIDATION_MESSAGE = 'Phone must contain 7 to 15 digits and may start with +.'

const PHONE_ALLOWED_FORMAT_RE = /^[\d\s().+-]+$/

export function sanitizePhoneInput(value) {
  const raw = String(value || '').trimStart()
  const hasLeadingPlus = raw.startsWith('+')
  const digits = raw.replace(/\D/g, '').slice(0, MAX_PHONE_DIGITS)

  if (hasLeadingPlus) return `+${digits}`
  return digits
}

export function normalizePhoneNumber(value) {
  const sanitized = sanitizePhoneInput(value).trim()
  return sanitized === '+' ? '' : sanitized
}

export function isValidPhoneNumber(value) {
  const normalized = normalizePhoneNumber(value)
  const digits = normalized.replace(/\D/g, '')

  return digits.length >= MIN_PHONE_DIGITS && digits.length <= MAX_PHONE_DIGITS
}

export function hasValidPhoneNumberCharacters(value) {
  const raw = String(value || '').trim()
  if (!raw) return true
  if (!PHONE_ALLOWED_FORMAT_RE.test(raw)) return false

  const plusCount = (raw.match(/\+/g) || []).length
  return plusCount === 0 || (plusCount === 1 && raw.startsWith('+'))
}
